import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../utils/seo';

export const Route = createFileRoute('/_layout/free-ai-audit-booking')({
  head: () => buildHead('/free-ai-audit-booking'),
});
